import { render } from "./m-good-road-panel.vue?vue&type=template&id=261627ba&scoped=true&ts=true"
import script from "./m-good-road-panel.vue?vue&type=script&lang=ts"
export * from "./m-good-road-panel.vue?vue&type=script&lang=ts"

import "./m-good-road-panel.vue?vue&type=style&index=0&id=261627ba&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261627ba"]])

export default __exports__